export const BACKGROUNDS_MAIN_MUTATION_SET_MAIN_SLIDE_BG = 'backgrounds_main_mutation_set_main_slide_bg'

export const BACKGROUNDS_MAIN_GETTER_GET_MAIN_SLIDE_BG_LIST = 'backgrounds_main_getter_get_main_slide_bg_list'
export const BACKGROUNDS_MAIN_GETTER_GET_URL_LIST = 'backgrounds_main_getter_get_url_list'

export const BACKGROUNDS_MAIN_ACTION_FETCH_MAIN_SLIDE_BG = 'backgrounds_main_action_fetch_main_slide_bg'
